import {useTranslation} from 'react-i18next'
import {QR_TYPES, type QrType} from '../../../common/constants/qrTypes'
import {trackEvent} from '../../../common/analytics/trackEvent'

interface QrTypeSelectorProps {
  type: QrType
  onChange: (type: QrType) => void
}

const QrTypeSelector = ({type, onChange}: QrTypeSelectorProps) => {
  const {t} = useTranslation()

  return (
    <div className="qrg-type-grid" role="tablist">
      {QR_TYPES.map((meta) => (
        <button
          key={meta.id}
          type="button"
          role="tab"
          aria-selected={meta.id === type}
          className={`qrg-type-btn${meta.id === type ? ' is-active' : ''}`}
          onClick={() => {
            onChange(meta.id)
            trackEvent('qr_type_changed', {type: meta.id})
          }}
        >
          {t(`qrGenerator.types.${meta.labelKey}`)}
        </button>
      ))}
    </div>
  )
}

export default QrTypeSelector
